import AuthContext from "./AuthContext";
import { useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import axios from './axios';
import { toast } from 'react-toastify';

function ProtectedWrapper({ children, allowedUserTypes, requiredCentre }) {
  const auth = useContext(AuthContext);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation(); // Track the current location

  const validateToken = async () => {
    try {
      if (auth.token) {
        const response = await axios.post('/users/checkAccessToken', {
          user_id: auth.user,
          access_token: auth.token,
        });

        if (response.data.message === "Access token is invalid or expired") {
          auth.signout();
          setIsAuthenticated(false);
          toast.error('Oops! Something Went Wrong');
          return;
        }
      }
      setIsAuthenticated(true);
    } catch (err) {
      console.error('Error checking token:', err);
      auth.signout();
    }
  };

  useEffect(() => {
    // Validate token when the component mounts
    validateToken();

  }, [auth.token, auth.user, auth.signout]);



  if (!auth.user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedUserTypes && !allowedUserTypes.includes(auth.userType)) {
    return <Navigate to="/" replace />;
  }

  if (requiredCentre && auth.centre !== requiredCentre) {
    return <Navigate to="*" />; // Optionally create a NoAccess page
  }

  if (!isAuthenticated) {
    return (
      <div 
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className='text-center loading-container'>
          {'Loading...'.split('').map((char, index) => (
            <span key={index} className='loading-letter font-semibold text-2xl text-indigo-700'>
              {char}
            </span>
          ))}
        </div>
      </div>
    );
  }

  return children;
}

export default ProtectedWrapper;
